import { parties } from '@/config'

const methods = {
  getPartyColor(party) {
    const obj = parties.find(
      item => item.match === party || item.name === party
    )
    if (obj) {
      return obj.color
    } else {
      return '#B0BEC5'
    }
  }
}

export default {
  methods
}
